import { useMutation, useQuery } from 'react-query';

import { hasRecoverableCognitoSession } from '@/infra/auth/cognitoToken';
import * as Types from './user.types';
import * as Repo from './user.repo';

export const useCurrentUser = (hasSessionCookie: boolean, userCode?: string, onSuccess?: (data: any) => void) =>
  useQuery(['getUser'], () => Repo.getUser(), { onSuccess, enabled: hasSessionCookie && !userCode });

// Identity of the back-office admin via Cognito token. Enabled when there is a
// recoverable Cognito session (valid id token or refresh token), not on mere cookie
// presence. `retry: false` because a failed renewal will not succeed on retry.
export const useAdminUser = () => {
  const hasCognitoSession = hasRecoverableCognitoSession();

  return useQuery(['getAdminUser'], () => Repo.getAdminUser(), { enabled: hasCognitoSession, retry: false });
};

export const useLogin = (opts) =>
  useMutation<Types.LoginResponse, Types.LoginError, Types.LoginRequest>(['login'], Repo.login, opts);

export const useCurrentUserByCode = (userCode?: string, onSuccess?: (data: any) => void) =>
  useQuery(['getUserByCode'], () => Repo.getUserByCode({ userCode }), { onSuccess, enabled: !!userCode });
